import React, { useEffect, useState } from 'react';
import { FaPen } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../Context/AuthContext';
import DummyImg from "../../Public/Images/568165.png";
const GallaryBox = ({ request_id, selectedImages, defaultImg, handleDefaultImage, onSelectFile, deleteHandler }) => {
    const { designation } = useAuth();

    const [isEditable, setIsEditable] = useState(true)
    const [searchParams,]= useSearchParams();
    const path = useLocation();
    const url = path.pathname;

//Restric user from edit image 

    useEffect(() => {
        if ((designation == "Manager" || designation == "Accountant")) {
          
            if (url.includes("add-units")) {
                setIsEditable(false)
            }

        }


        if (url.includes("details")) {
            setIsEditable(false)
        }
        if (request_id) {
            setIsEditable(false)
        }
        if (searchParams.get("taskid")) {
            setIsEditable(false)
        }
    }, [url, designation, request_id,searchParams])


    return (
        <div className="col-xl-5 col-xxl-4 d-flex justify-content-xl-end mt-5 mt-xl-0">
            <div className="area-hide add-building-img">
                <div className="image-area d-flex align-items-center justify-content-center position-relative">
                    {selectedImages.length > 0 ? (
                        <img
                            id="show-image"
                            src={defaultImg ? defaultImg : selectedImages[0]?.url}
                            alt=""
                        />
                    ) : (
                        <img id="show-image" src={DummyImg} />
                    )}

                    {isEditable && <div className="img-upload">
                        <label htmlFor="building_image" className="img-upload-lbl">
                            <FaPen className="edit-pen" color="black" />
                        </label>

                        <input
                            type="file"
                            className="form-control d-none"
                            id="building_image"
                            name="building_image"
                            accept="image/*"
                            multiple
                            // onChange={onFileUpload}
                            onChange={onSelectFile}
                        />
                    </div>}
                </div>
                <div className="add-images d-flex ">
                    {selectedImages?.map((url, index) => {
                        return (
                            <div className="img-sec" key={index}>
                                <img
                                    id="show-image"
                                    src={url?.url}
                                    alt=""
                                    onClick={() => handleDefaultImage(url?.url)}
                                // onClick={() => onClickImages(url?.url)}
                                />
                                {isEditable && <MdCancel
                                    className="image_cancel"
                                    onClick={() => {
                                        deleteHandler(url?.url);
                                        ;
                                    }}
                                />}
                            </div>
                        );
                    })}
                    {isEditable && (
                        <div className="img-sec d-flex align-items-center justify-content-center form-control">
                            <label
                                htmlFor="building_image"
                                className="img-upload-lbl img-add-btn fs-4"
                            >
                                +
                            </label>
                        </div>
                    )}
                    {selectedImages && selectedImages.length > 10 && (
                        <div
                            className="error error-message"
                            style={{ color: "red" }}
                        >
                            You can't upload more than 10 images! <br />
                            <span>
                                please delete <b> {selectedImages.length - 10} </b> of
                                them{" "}
                            </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default GallaryBox